import React, {
  createContext,
  FC,
  ReactNode,
  useState,
  useContext
} from 'react';

interface IActionProps {
  setIsSettingsDrawerOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IContextProps {
  isSettingsDrawerOpened: boolean;
}

interface IProviderProps {
  children: ReactNode;
}

export const StateContext = createContext<IContextProps | undefined>(undefined);
export const DispatchContext = createContext<IActionProps | undefined>(
  undefined
);

export const SettingsMenuProvider: FC<IProviderProps> = ({ children }) => {
  const [isSettingsDrawerOpened, setIsSettingsDrawerOpened] = useState(false);

  const contextDispatchValue = {
    setIsSettingsDrawerOpened
  };

  const contextValue = {
    isSettingsDrawerOpened
  };
  return (
    <DispatchContext.Provider value={contextDispatchValue}>
      <StateContext.Provider value={contextValue}>
        {children}
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
};

export const useSettingContext = (): IContextProps => {
  const context = useContext(StateContext);

  if (!context) {
    throw new Error(
      'useSettingContext must be used within a SettingsMenuProvider'
    );
  }

  return context;
};

export const useSettingDispatch = (): IActionProps => {
  const context = useContext(DispatchContext);

  if (!context) {
    throw new Error(
      'useSettingDispatch must be used within a SettingsMenuProvider'
    );
  }

  return context;
};
